<template>
  <div>
    <CCard class="bg-style2">
      <CCardHeader class="bg-gradient-danger text-white" style="border-top-left-radius: 1rem; border-top-right-radius: 1rem ">
        <span class="font-weight-bold h6"> <CIcon v-if="icon" :name="icon"/> {{ caption }} </span>

        <div class="card-header-actions">

          <CButton v-if="!disable"
                   class="mr-1" v-c-tooltip.hover.click="'Download Excel'" size="sm" color="info" shape="pill"
                   @click="download('Core Competency Assessment Summary by Department')"
          >
            <CIcon name="cil-cloud-download"/>
          </CButton>
          Total : {{item.length}}
        </div>

      </CCardHeader>
      <CCardBody>

        <CRow v-if="!disable && role == 1">
          <CCol></CCol>
          <CCol col="6">
            <CChartDoughnut
                :datasets="onDataChart3(item)"
                :labels="[ 'No Gap : '+onDataChart3(item)[0].value[0]+' ( '+onDataChart3(item)[0].data[0]+'% )', 'Gap found  : '+onDataChart3(item)[0].value[1]+' (  '+onDataChart3(item)[0].data[1]+'% )' ]"
            />
          </CCol>
          <CCol/>
        </CRow>

        <CDataTable
            :table-filter="{label:''}"
            :hover="hover"
            :striped="striped"
            :bordered="bordered"
            :small="small"
            :fixed="fixed"
            :items="item"
            :fields="fields"
            :items-per-page="small ? 50 : 20"
            :dark="dark"
            :loading="loading"
            pagination
            :items-per-page-select="pages"
            sorter
        >
          <template #index="{item,index}">
            <td class="text-center"  @click="toggleDetails(item, index)"> {{ index + 1 }}</td>
          </template>


          <template #completed="{item,index}">
            <td class="text-center" > {{ item.completed }} {{ '( ' + ((item.completed / item.total) * 100).toFixed(2).replace("NaN","0.00") + '% )' }}</td>
          </template>

          <template #total="{item,index}">
            <td class="text-center" > {{ item.total }}</td>
          </template>

          <template #pending="{item,index}">
            <td class="text-center" > {{ item.pending }} {{ '( ' + ((item.pending / item.total) * 100).toFixed(2).replace("NaN","0.00") + '% )' }}</td>
          </template>

          <template #doing="{item,index}">
            <td class="text-center" > {{ item.doing }} {{ '( ' + ((item.doing / item.total) * 100).toFixed(2).replace("NaN","0.00") + '% )' }}</td>
          </template>

<!--          <template #member="{item,index}">-->
<!--            <td class="text-center" @click="toggleDetails(item, index)">-->
<!--              {{ item.total }}-->
<!--            </td>-->
<!--          </template>-->

          <template #isNoGap="{item,index}">
            <td class="text-center" > {{ item.isNoGap }} {{ '( ' + ((item.isNoGap / item.member) * 100).toFixed(2).replace("NaN","0.00") + '% )' }}</td>
          </template>

          <template #isGap="{item,index}">
            <td class="text-center" > {{ item.isGap }} {{ '( ' + ((item.isGap / item.member) * 100).toFixed(2).replace("NaN","0.00") + '% )' }}</td>
          </template>

          <template #action="{item,index}">
            <td style="width: 140px">
              <CRow>
                <CCol class="text-center">
                  <CButton class="mr-1"  size="sm" color="info" v-c-tooltip.hover.click="'Open Details'" shape="pill" variant="outline" @click="toggleDetails(item, index)"  >
                    <CIcon name="cil-description"/>
                  </CButton>


                  <CButton v-if="!isHris" class="mr-1"  size="sm" color="warning" v-c-tooltip.hover.click="'Download Excel'" shape="pill" variant="outline" @click="toggleDetailsAndDownload(item, index)"  >
                    <CIcon name="cil-cloud-download"/>
                  </CButton>

                </CCol>
              </CRow>
            </td>
          </template>
          <template #details="{item,index}">

            <CCollapse :show="Boolean(item._toggled)" :duration="collapseDuration">
              <CRow v-if="disable">
                <CCol></CCol>
                <CCol col="6">
                  <CChartDoughnut
                      :datasets="onDataChart(item)"
                      :labels="['ยังไม่ได้ประเมิน ( '+onDataChart(item)[0].data[0]+'% )', 'อยู่ระหว่างประเมิน ( '+onDataChart(item)[0].data[1]+'% )', 'ประเมินเสร็จสิ้น( '+onDataChart(item)[0].data[2]+'% )' ]"
                  />
                </CCol>
                <CCol></CCol>
              </CRow>
              <CRow v-if="!disable">
                <CCol></CCol>
                <CCol col="6">
                  <CChartDoughnut
                      :datasets="onDataChart2(item)"
                      :labels="[ 'No Gap ( '+onDataChart2(item)[0].data[0]+'% )', 'Gap found ( '+onDataChart2(item)[0].data[1]+'% )' ]"
                  />
                </CCol>
                <CCol/>
              </CRow>

              <CRow class="mt-3" v-if="!disable && role == 1" >
                <CCol>
                  <ReportCompetency2 class="mb-3" :item="item.explorerAgency" :loading="loading" />
                </CCol>
              </CRow>
              <CDataTable
                  :table-filter="{label:''}"
                  :fields="childrenFields"
                  :items="item.item"
                  items-per-page-select
                  :items-per-page="20"
                  hover
                  pagination
                  :items-per-page-select="pages"
                  sorter
              >
                <template #index="{item,index}">
                  <td class="text-center"  @click="toggleDetails(item, index)"> {{ index + 1 }}</td>
                </template>


                <template #competencyLevel="{item,index}">
                  <td class="text-center font-weight-bold"  @click="toggleDetails(item, index)"> {{ item.competencyLevel}}</td>
                </template>
                <template #assessment0="{item,index}">
                  <td class="text-center font-weight-bold" :class="color(item.competencyLevel,item.assessment0)" @click="toggleDetails(item, index)"> {{ item.assessment0}}</td>
                </template>

                <template #assessment1="{item,index}">
                  <td class="text-center font-weight-bold" :class="color(item.competencyLevel,item.assessment1)"  @click="toggleDetails(item, index)"> {{ item.assessment1}}</td>
                </template>

                <template #assessment2="{item,index}">
                  <td class="text-center font-weight-bold" :class="color(item.competencyLevel,item.assessment2)" @click="toggleDetails(item, index)"> {{ item.assessment2}}</td>
                </template>

                <template #gapSum="{item,index}">
                  <td class="text-center font-weight-bold" :class="color(0,item.gapSum)" @click="toggleDetails(item, index)"> {{ item.gapSum }}</td>
                </template>


                <template #action="{item,index}">
                  <td style="width: 140px">
                    <CRow>
                      <CCol class="text-center">
                        <CButton class="mr-1" v-c-tooltip.hover.click="'Remove'" size="sm" color="danger" shape="pill" variant="outline" @click="onRemove(item,index)"  >
                          <CIcon name="cil-trash"/>
                        </CButton>

                      </CCol>
                    </CRow>
                  </td>
                </template>

              </CDataTable>
            </CCollapse>
          </template>

        </CDataTable>
      </CCardBody>
    </CCard>

  </div>
</template>

<script>

import {mapGetters} from 'vuex'
import Vue from 'vue'
import moment from "moment";

import {CChartDoughnut} from '@coreui/vue-chartjs'
import ReportCompetency2 from "@/projects/views/E-Performances/Dashboard/Admin/components/ReportCompetency2";
import * as XLSX from "xlsx";

export default {
  components: {ReportCompetency2, CChartDoughnut},
  name: 'History',
  props: {
    icon: {
      type: String,
      default: 'cil-user'
    },
    caption: {
      type: String,
      default: 'Banks'
    },

    item:{
      type: Array,
      default() {
        return []
      }
    },
    fields: {
      type: Array,
      default() {
        return [
          {key:"index", label: "#",  _style: 'width:50px; text-align: center'},
          {key:"code", label:"Code", _style: 'width:30px; text-align: center'},
          {key:"title", label:"Title", },
          {key:"member", label: "Total",_style: 'width:30px; text-align: center' },

          {key:"isGap", label: "Gap found",_style: 'width:150px; text-align: center' },
          {key:"isNoGap", label: "No Gap",_style: 'width:150px; text-align: center' },
          // {key:"isMeets", label: "Meets", _style: 'width:150px; text-align: center'},
          // {key:"isExceeding", label: "Exceeding", _style: 'width:150px; text-align: center'},

          {key:"action", label: "#", _style: 'width:30px; text-align: center'}
        ]
      }
    },
    childrenFields: {
      type: Array,
      default() {
        return [
          {key:"index", label: "#",  _style: 'width:50px; text-align: center'},
          {key:"year", label:"year", _style: 'width:50px; text-align: center'},
          {key:"code", label:"รหัสพนักงาน", _style: 'width:120px;'},
          {key:"info", label:"ชื่อ - นามสกุลพนักงาน" , _style: 'width:300px;'},
          {key:"cc", label:"ชื่อรายการสมรรถนะ", _style: 'width:350px;'},
          {key:"competencyLevel", label:"ระดับที่คาดหวัง",_style: 'width:120px; text-align: center' },
          {key:"assessment0", label:"ประเมินตนเอง", _style: ' width:120px; text-align: center' },
          {key:"assessment1", label:" ผู้ประเมิน 1", _style: ' width:120px; text-align: center' },
          {key:"assessment2", label:" ผู้ประเมิน 2", _style: ' width:120px; text-align: center' },
          {key:"gapSum", label:" สรุปผล", _style: ' width:120px;text-align: center' },
        ]
      }
    },
    type: {
      type: String,
      default: 'cil-user'
    },
    hover: Boolean,
    striped: Boolean,
    bordered: Boolean,
    small: Boolean,
    fixed: Boolean,
    dark: Boolean,

    isHris: {
      type: Boolean,
      default: true
    },

    pages:{
      type: Object,
      default() {
        return {
          values:[10,20,50,100]
        }
      }
    },
    loading:{
      type: Boolean,
      default() {
        return false
      }
    },
    disable: {
      type: Boolean,
      default() {
        return false
      }
    }
  },

  data: function () {
    return {
      role:this.$store.getters['personal/profile'].role,
      collapseDuration: 0,
      defaultDatasets: [{
        backgroundColor: [
          '#636f83',
          '#f9b115',
          '#2eb85c',
        ],
        data: [40, 20, 10]
      }]

    }
  },

  mounted() {
  },

  created() {
    this.onInit()

  },
  beforeDestroy() {

  },

  methods: {
    onInit() {
      this.onLoad();
    },

    onLoad() {

    },



    download(name) {

      var items = []
      // console.log(this.item)
      for(var i=0; i<this.item.length; i++){
        for(var j=0; j<this.item[i].item.length; j++){
          var objs = this.item[i].item[j];
          var objsD = {};
          objsD['หน่วยงาน'] = this.item[i].title;
          objsD['รหัสพนักงาน'] = objs.code;
          objsD['ชื่อ - นามสกุลพนักงาน'] = objs.info;
          objsD['ปีการประเมิน (ปี พ.ศ.)'] = objs.year;
          objsD['รหัสข้อมูลรายการสมรรถนะ'] = objs.cc.split("-")[0];
          objsD['ชื่อรายการสมรรถนะ'] = objs.cc.split("-")[1];
          objsD['ระดับที่คาดหวัง'] = objs.competencyLevel;
          objsD['ประเมินตนเอง'] = objs.assessment0;
          objsD['ผู้ประเมิน 1'] = objs.assessment1;
          objsD['ผู้ประเมิน 2'] = objs.assessment2;
          objsD['สรุปผล'] = objs.gapSum;

          items.push(objsD)
        }



        // console.log(items)
      }

      const worksheet = XLSX.utils.json_to_sheet(items);
      worksheet['!cols'] = [
        { wpx: 170 }, { wpx: 80 }, { wpx: 170 }, { wpx: 115 }, { wpx: 136 },
        { wpx: 170 }, { wpx: 80 }, { wpx: 80 }, { wpx: 80 },
      ];

// สร้าง workbook และเพิ่ม worksheet แรก
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "All");

// บันทึกไฟล์
      XLSX.writeFile(workbook, name+".xlsx");


      // var result = item.item.map(objs => ({
      // 'รหัสพนักงาน': objs.code,
      // 'ชื่อ - นามสกุลพนักงาน': objs.info,
      // 'ปีการประเมิน (ปี พ.ศ.)': objs.year,
      // 'รหัสข้อมูลรายการสมรรถนะ': objs.cc.split("-")[0],
      // 'ชื่อรายการสมรรถนะ': objs.cc.split("-")[1],
      // 'ระดับที่คาดหวัง': objs.competencyLevel,
      // 'ประเมินตนเอง': objs.assessment0,
      // 'ผู้ประเมิน 1': objs.assessment1,
      // 'ผู้ประเมิน 2': objs.assessment2,
      // 'สรุปผล': objs.gapSum
      // }));


    },
    downloads(name) {

      var objs = this.item

      var objsArray = [];
      for(var i=0; i<objs.length; i++){
        var objCC = [];

        var data = {};
        data.code = objs[i].code;
        data.title = objs[i].title;
        data.tital = objs[i].member;
        data.gapFound = objs[i].isGap + ' ( ' + ((objs[i].isGap / objs[i].total) * 100).toFixed(2) + '% )' ;
        data.noFound = objs[i].isNoGap + ' ( ' + ((objs[i].isNoGap / objs[i].total) * 100).toFixed(2) + '% )' ;


        for(var j=0; j<objs[i].explorerAgency.length; j++){
          var objsExplorer = {};
          objsExplorer.title = objs[i].explorerAgency[j].title
          objsExplorer.total = objs[i].explorerAgency[j].total
          objsExplorer.gapFound = objs[i].explorerAgency[j].isGap + ' ( ' + ((objs[i].explorerAgency[j].isGap / objs[i].explorerAgency[j].total) * 100).toFixed(2) + '% )' ;
          objsExplorer.noFound = (objs[i].explorerAgency[j].total - objs[i].explorerAgency[j].isGap) + ' ( ' + (( (objs[i].explorerAgency[j].total - objs[i].explorerAgency[j].isGap) / objs[i].explorerAgency[j].total) * 100).toFixed(2) + '% )' ;
          objsExplorer.isMeets = objs[i].explorerAgency[j].isMeets + ' ( ' + ((objs[i].explorerAgency[j].isMeets / objs[i].explorerAgency[j].total) * 100).toFixed(2) + '% )' ;
          objsExplorer.isExceeding = objs[i].explorerAgency[j].isExceeding + ' ( ' + ((objs[i].explorerAgency[j].isExceeding / objs[i].explorerAgency[j].total) * 100).toFixed(2) + '% )' ;

          objCC.push(objsExplorer)

        }
        data.history = objCC;

        objsArray.push(data)
      }

      const wb = XLSX.utils.book_new()
      for(var i=0; i<objsArray.length; i++){
        var nameSheet = objsArray[i].code.toString()


        const summary = [
          { Title: objsArray[i].title, Total: objsArray[i].total, GapFound: objsArray[i].gapFound, NoGap: objsArray[i].noFound },
        ];

        // ข้อมูลย่อย (จาก history)
        const details = objsArray[i].history.map((historyItem) => ({
          Title: historyItem.title,
          Total: historyItem.total,
          GapFound: historyItem.gapFound,
          NoGap: historyItem.noFound,
          Meets: historyItem.isMeets,
          Exceeding: historyItem.isExceeding,
        }));

        const sheetData = [{ Title: "Title", Total: "Total", GapFound: "Gap found", NoGap: "No Gap"},...summary, {},{ Title: "Title", Total: "Total", GapFound: "Gap found", NoGap: "No Gap", Meets: "Meets", Exceeding: "Exceeding" }, ...details]

        // แปลงข้อมูลเป็น sheet
        const sheet = XLSX.utils.json_to_sheet(sheetData, { skipHeader: true });


        // const dataX = XLSX.utils.json_to_sheet(objsArray[i].history)
        sheet['!cols'] = [
          { wpx: 500 }, // Title
          { wpx: 80 },  // Total
          { wpx: 100 }, // Gap found
          { wpx: 100 }, // No Gap
          { wpx: 100 }, // Meets
          { wpx: 100 }, // Exceeding
        ];
        XLSX.utils.book_append_sheet(wb, sheet, nameSheet)
      }
      XLSX.writeFile(wb,name+'.xlsx')
    },

    onDataChart(item){
      return  [{
        backgroundColor: [
          '#636f83',
          '#f9b115',
          '#2eb85c',
        ],
        data: [ ((item.pending / item.total) * 100).toFixed(2),((item.doing / item.total) * 100).toFixed(2),((item.completed / item.total) * 100).toFixed(2) ]
      }]
    },

    onDataChart2(item){
      return  [{
        backgroundColor: [
          '#2eb85c',
          '#DD1B16',
        ],
        data: [((item.isNoGap / item.member) * 100).toFixed(2), ((item.isGap / item.member) * 100).toFixed(2)]
      }]
    },

    onDataChart3(item){
      var isGap = item.reduce(function (old, objs) {
        return old + objs.isGap;
      }, 0);
      var isNoGap = item.reduce(function (old, objs) {
        return old + objs.isNoGap;
      }, 0);
      var isMember = item.reduce(function (old, objs) {
        return old + objs.member;
      }, 0);

      return  [{
        backgroundColor: [
          '#2eb85c',
          '#DD1B16',
        ],
        data: [((isGap / isMember) * 100).toFixed(2), ((isNoGap / isMember) * 100).toFixed(2)],
        value:[isGap,isNoGap]
      }]
    },


    toggleDetails (item,index) {
      item._toggled = !item._toggled
      this.collapseDuration = 300
      this.$nextTick(() => { this.collapseDuration = 0})
      // this.$emit('info',item)
    },

    toggleDetailsAndDownload(item,index) {var result = item.item.map(objs => ({
      'รหัสพนักงาน': objs.code,
      'ชื่อ - นามสกุลพนักงาน': objs.info,
      'ปีการประเมิน (ปี พ.ศ.)': objs.year,
      'รหัสข้อมูลรายการสมรรถนะ': objs.cc.split("-")[0],
      'ชื่อรายการสมรรถนะ': objs.cc.split("-")[1],
      'ระดับที่คาดหวัง': objs.competencyLevel,
      'ประเมินตนเอง': objs.assessment0,
      'ผู้ประเมิน 1': objs.assessment1,
      'ผู้ประเมิน 2': objs.assessment2,
      'สรุปผล': objs.gapSum
    }));

      const worksheet = XLSX.utils.json_to_sheet(result);
      worksheet['!cols'] = [
        { wpx: 80 }, { wpx: 170 }, { wpx: 115 }, { wpx: 136 },
        { wpx: 170 }, { wpx: 80 }, { wpx: 80 }, { wpx: 80 },
      ];

// สร้าง workbook และเพิ่ม worksheet แรก
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, item.code+"");

// คำนวณผลสรุป
      const result1 = Array.from({ length: Math.ceil(result.length / 7) }, (_, i) => {
        const subset = result.slice(i * 7, (i + 1) * 7);
        const summary = subset.map(obj => obj['สรุปผล']);

        return {
          'รหัสพนักงาน': subset[0]['รหัสพนักงาน'],
          'ชื่อ - นามสกุลพนักงาน': subset[0]['ชื่อ - นามสกุลพนักงาน'],
          'ประเมินตนเอง': subset[0]['ประเมินตนเอง'],
          'ระดับที่คาดหวัง': subset[0]['ระดับที่คาดหวัง'],
          'ตรงตามความคาดหวัง': summary.every(val => val === 0) ? 1 : 0,
          'สูงกว่าความคาดหวัง': summary.every(val => val > 0) ? 1 : 0,
          'ต่ำกว่าตามความคาดหวัง': summary.some(val => val !== 0 && val <= 0) ? 1 : 0
        };
      });

      const worksheet1 = XLSX.utils.json_to_sheet(result1);
      worksheet1['!cols'] = [
        { wpx: 80 }, { wpx: 170 }, { wpx: 100 }, { wpx: 100 }, { wpx: 130 },{ wpx: 130 },{ wpx: 130 },
      ];

// เพิ่ม worksheet ที่สองเข้าไปใน workbook เดิม
      XLSX.utils.book_append_sheet(workbook, worksheet1, item.code+"1");

// บันทึกไฟล์
      XLSX.writeFile(workbook, item.title+".xlsx");


    },

    onRemove(item,index) {
      var body = {};
      body._id = item._id;

      this.$store.dispatch("assessment/remove",body)
    },

    color(level,checck){
      if(level > checck){
        return "text-danger"
      }else if(level == checck){
        return "text-success"
      }else{
        return "text-info"
      }

    }
  },

  computed: {
    ...mapGetters({
      lang: "setting/lang",
    })
  },

  watch: {}
}
</script>
<style>

.w50 {
  min-width: 50%;
}

.input-group-append .form-group {
  margin-bottom: 0px;
}

.text-right {
  text-align: end;
}

.bg-login1 {
  border-radius: 1.5rem;
  background: linear-gradient(180deg, #a54af0 0%, #539cf8 60%, #C8CED3 80%);
}
</style>
